<template>
    <div class="buyingBehavior">
        <dataAnalysisTemplate
            :echoData="echoData"
            :showData="crowdPortrait"
            @save="save"
            :viewData="viewData"
        ></dataAnalysisTemplate>
    </div>
</template>

<script>
import dataAnalysisTemplate from './dataAnalysisTemplate';
import { getDataAnalysisInfo } from '../../../../utils/apis';

export default {
    name: 'buyingBehavior',
    components: {
        dataAnalysisTemplate,
    },
    data() {
        return {
            viewData: {},
            crowdPortrait: 'buyingBehavior',
            echoData: {},
        };
    },
    methods: {
        save(val) {
            // val.name = 'buyingBehavior'
            // this.$emit('save', val)
            this.$emit('save', 2, val);
            // sessionStorage.setItem('buyingBehavior', JSON.stringify(val))
        },
        async getDataAnalysisInfoFn() {
            let res = await getDataAnalysisInfo({
                type: 2,
            });
            this.echoData = res.data;
        },
    },
    mounted() {
        this.getDataAnalysisInfoFn();
    },
};
</script>

<style scoped>
.buyingBehavior {
    width: 100%;
    height: 100%;
}
</style>
